export default __webpack_public_path__ + "media/zurb/img/services/services/email-design-img-8696fbdf80f8f64805f2328997b732b3.png";